/**
 * ### v-tooltip
 *  * `arg` -  position:ToolTipPosition
 *  * `modifier` - list:display as list
 *  * static data using v-tooltip='someStaticStringOrExpression'
 *  * dynamic data using :tooltip-data attr binding
 * ## General
 * 1. there is a <TheToolTip/> in App.vue which is only visible after
 * firing an EventBus.$emit('toolip-show',...) msg.
 * 2. we have also added a Vue.prototype.$tooltip(...) so that we can work with it inside
 *    the components script.
 *
 * ### Hiding the tooltip when needed
 * use :tooltip-hide="boolExpression"
 */
import { EventBus } from "@/eventbus";
import Vue from "vue";
import { TooltipMsgType, ToolTipPosition } from "./tooltip.model";

type MouseEnterListener = (ev: MouseEvent) => void;
const listenerMap = new Map<string, MouseEnterListener>();

const uniqId = (() => {
  let _id = 1;
  return () => {
    _id++;
    return "tooltip_" + _id;
  };
})();

Vue.directive("tooltip", {
  inserted(el, bindings) {
    const msg = bindings.value || "";
    const position: ToolTipPosition = bindings.arg as ToolTipPosition;
    let type: TooltipMsgType = "simple";
    const isList = bindings.modifiers.list;
    const is_points = bindings.modifiers.points;
    const isIconList = bindings.modifiers.iconList;
    isList && (type = "list");
    isIconList && (type = "iconList");
    is_points && (type = "points");

    const html = bindings.modifiers.html;
    const uniqueId = uniqId();
    el.setAttribute("sldx-tooltip-listener-id", uniqueId);
    const listener = mouseEnterHandler(uniqueId, el, msg, position, type, html);
    listenerMap.set(uniqueId, listener);
    el.addEventListener("mouseenter", listener);
  },
  unbind(el) {
    const uniqueId = el.getAttribute("sldx-tooltip-listener-id") as string;
    const listener = listenerMap.get(uniqueId) as MouseEnterListener;
    el.removeEventListener("mouseenter", listener);
    listenerMap.delete(uniqueId);
  },
});

function mouseEnterHandler(
  id: string,
  el: HTMLElement,
  msg: string,
  position: ToolTipPosition,
  type: TooltipMsgType,
  asHtml = false
) {
  return (ev: MouseEvent) => {
    const element = ev.target as HTMLElement;
    const hideTooltip: boolean =
      element.getAttribute("tooltip-hide") === "true";
    if (hideTooltip) {
      return;
    }
    const data = element.getAttribute("tooltip-data");
    if (data) {
      // @ts-ignore
      msg =
        type === "iconList" || type === "list" || type == "points"
          ? data.split(",")
          : data;
    }

    EventBus.emit("tooltip", {
      id,
      type,
      msg,
      position,
      el,
      asHtml,
    });
  };
}

/* 
Vue.directive("width", {
  inserted(el, bindings) {
    const elId = bindings.value || "";
    
   const elWidth =  document.getElementById(elId);
     
    const uniqueId = uniqId();
  
   
  },
  unbind(el) {
    const uniqueId = el.getAttribute("sldx-tooltip-listener-id") as string;
    const listener = listenerMap.get(uniqueId) as MouseEnterListener;
    el.removeEventListener("mouseenter", listener);
    listenerMap.delete(uniqueId);
  },
}); */
